// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
    factory('apps', ['$http', 'obexConstant', 'authService',
      function ($http, obexConstant, authService) {
        return {
          addApp(app) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const postData = {
                CategoryId: app.CategoryId,
                Name: app.Name
              };
              return $http.post(obexConstant.urlApp, postData, {
                headers: authHeader,
              });
            });
          },
          getApps() {
            return authService.getAuthorizationHeader().then(authHeader => {
              return $http.get(obexConstant.urlApp, {
                headers: authHeader,
              });
            });
          },
          getAppById(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlApp}/id/${id}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },
          updateApp(id, app) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlApp}/id/${id}`;
              const putData = {
                Id: app.Id,
                CategoryId: app.CategoryId,
                Name: app.Name
              };
              return $http.put(url, putData, {
                headers: authHeader,
              });
            });
          },
          deleteApp(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlApp}/id/${id}`;
              return $http.delete(url, {
                headers: authHeader,
              });
            });
          },
        };
      },
    ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/apps.service.js